import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from './Header';
import Setting from './Setting';
import HeaderCombine from './HeaderCombine';
import { Button, Radio, Icon } from 'antd';
import { Layout,  Row, Col } from 'antd';
const { Header, Footer, Sider, Content } = Layout;

const NotFoundPage = () => (
  <Layout>
    <Header>
      <HeaderCombine showProfile={false}/>
    </Header>
    <Content>
      <div className="error-container">
          <h1>Page not found - 404</h1> 
          <div>
          <a href="/">
          <Button type="primary">
            <Icon type="home" />Home
          </Button>
          </a>
          </div>
      </div>
    </Content>
  </Layout>

);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/NotFoundPage.js